<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--finishing">
            <h1 class="text-center pad-top--xl z-up text-white text-caps">
                Garment Finishing and Relabelling
            </h1>
            <h5 class="text-center text-white pad-top--large pad-bottom--xl text-caps">
                <router-link to="/contact-us" class="text-white">
                    Get in touch now for a free quote
                </router-link>
            </h5>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--lilac" style="margin-top:-10px">
            <div class="cell small-12 medium-8">
                <p class="pad--large feature-text">
                    The final stage before your personalised clothing is dispatched to directly to
                    you is garment finishing and or relabelling. We provide a number of finishing
                    and relabelling services which can help to add the finishing touches to your
                    chosen garment. Our UK based manufacturing facility is capable of relabelling
                    and packing over 100,000 t-shirts a month!
                </p>
            </div>
            <div class="cell small-12 medium-4">
                <div class="pad--large">
                    <img src="../../../static/images/customisation/fn-bg.png" alt="" />
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--lilac-dk">
            <div class="cell small-12 medium-4">
                <div class="zoom-image">
                    <img src="../../../static/images/customisation/eb-example.png" alt="" />
                </div>
            </div>
            <div class="cell small-12 medium-4">
                <div class="zoom-image">
                    <img src="../../../static/images/customisation/eb-example-2.png" alt="" />
                </div>
            </div>
            <div class="cell small-12 medium-4">
                <div class="zoom-image">
                    <img src="../../../static/images/customisation/eb-example-3.png" alt="" />
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--swoosh-top-right">
            <div class="cell small-12 medium-8 medium-offset-2 text-center">
                <span class="image-decoraction">
                    <img width="70px" src="../../../static/images/customisation/time-money.png" alt="" />
                </span>
                <span class="image-decoraction">
                    <img width="80px" src="../../../static/images/customisation/stopwatch.png" alt="" />
                </span>
                <span class="image-decoraction">
                    <img width="60px" src="../../../static/images/customisation/knowledge.png" alt="" />
                </span>
                <h2 class="feature-heading pad-top pad-bottom">Quick - Cost effective - Experts</h2>
                <p class="feature-text">
                    We provide high quality woven labels which we can stitch into your garment to
                    give the perception of a bespoke custom-made piece of clothing unique to your
                    brand or business. Individual folding and bagging is a common process within
                    our factory enabling you to sell straight out of the box. We quality check
                    every order at 3 stages during to production process meaning you don’t have to!
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl bg--dk-blue">
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/barclays.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/google.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/microsoft.png" alt="" />
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-bottom--xl pad-top bg--dk-blue">
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/bbc.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/british-gas.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/bentley.png" alt="" />
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top bg--swoosh-top-left">
            <div class="cell small-12 medium-8 medium-offset-2 text-center">
                <p class="feature-text">
                    Processes:
                </p>
                <p class="feature-text">
                    Neck labels:<br />Woven inner neck labels are a very common method of branding
                    a garment. We can re-brand a piece of clothing by either cutting (cut and sew)
                    or unpicking (unpick and sew) the proprietary label already in the garment to
                    remove it so that we can add your own brand or business into the neck seam.
                </p>
                <p class="feature-text">
                    Screen printed inner neck labels:<br />Screen printing is a great way to add
                    branding and wash care instructions into the inner neck area for a medium to
                    high quantity order and can be printed up to 4 colours depending on the number
                    of garments being printed.
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xxl bg--swoosh-bottom-right">
            <div class="cell small-12 medium-8 medium-offset-2 text-center">
                <p class="feature-text">
                    Hem or sleeve labels:<br />Similar to inner neck labels these woven labels can
                    be added onto the hem of a garment, the sleeve, edge of a hood or cuff. This
                    is a less time consuming process given we are not removing the proprietary
                    label. Hem labels have a different size and shape to inner neck labels so when
                    you’re designing your woven labels ask one of our experts for a helping hand.
                </p>
                <p class="feature-text">
                    Swing Tags:<br />We can manufacture custom printed swing tags onto a whole
                    range of materials. Our number one choice is 360gsm premium silk board, flat
                    or folded and printed full colour to one or both sides.
                </p>
                <p class="feature-text">
                    Individual folding and bagging:<br />This is a service we’re particularly fond
                    of, individual folding and bagging allows you to distribute your garments
                    straight out of the box. It also helps to keep garments clean during transit
                    and if you’re looking for eco-friendly solution ask one of our team about
                    biodegradable poly bags!
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xxxl pad-bottom--large bg--lilac relative">
            <span class="top-center-badge">
                <img src="../../../static/images/customisation/top-badge.png" alt="" />
            </span>
            <div class="cell small-12">
                <div class="grid-x grid-padding-x">
                    <div class="cell small-12 medium-8 medium-offset-2">
                        <p class="text-center">
                            <span class="button-text">Contact Us</span>
                        </p>
                    </div>
                </div>
                <form v-on:submit="sendContactForm">
                    <div class="grid-x grid-padding-x pad-top">
                        <div class="cell small-12 medium-3 medium-offset-2">
                            <input required v-model="contact.name" class="featured-input" type="text" placeholder="name">
                        </div>
                        <div class="cell small-12 medium-5">
                            <input required v-model="contact.message" class="featured-input" type="text" placeholder="Selection E.g Screen printing">
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x pad-top--small">
                        <div class="cell small-12 medium-4 medium-offset-2">
                            <input required v-model="contact.email" class="featured-input" type="email" placeholder="Email address">
                        </div>
                        <div class="cell small-12 medium-4">
                            <input required v-model="contact.telephone" class="featured-input" type="text" placeholder="Telephone">
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x pad-top">
                        <div class="cell small-12 medium-8 medium-offset-2">
                            <p class="text-center">
                                <button class="button-text link">Send</button>
                            </p>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xxxl pad-bottom--large bg--dk-blue">
            <div class="cell small-12">
                <p class="text-center text-white">
                    <img width="50px" src="../../../static/images/customisation/tel.png" alt="" />
                    &nbsp;0116 467 0260&nbsp;
                    <img width="50px" src="../../../static/images/customisation/mail.png" alt="" />
                    &nbsp;info@customisedclothing.com&nbsp;
                    <img width="50px" src="../../../static/images/customisation/clock.png" alt="" />
                </p>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import axios from '../../axios';

export default {
    name: 'Finishing',
    metaInfo() {
        return {
            title: 'Garment Finishing | Custom Relabelling UK',
            titleTemplate: '%s - CustomisedClothing',
            meta: [
                { description: 'Add the finishing touches to your personalised clothing with our garment finishing and relabelling services. Explore our customisation options now.' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/screenprinting' },
            ],
        };
    },
    data() {
        return {
            contact: {
                name: '',
                email: '',
                message: '',
            },
        };
    },
    methods: {
        sendContactForm(event) {
            event.preventDefault();
            axios.post('/Contacts/addContact.json', this.contact)
                .then(() => {
                    this.$router.push('/contact-thankyou');
                });
        },
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/GarmentFinishing.vue